import React from "react";
import ChatInterface from "@commons/chat/components/ChatInterface";

const SupportChat = () => {
  return <ChatInterface />;
};

export default SupportChat;
